// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I3i7","index":"styles_index__2I6Fy"};